// src/config/sponsor.js — Configuración modular de patrocinador
// Para remover Sika: set ACTIVE_SPONSOR = null
// Para cambiar sponsor: modificar este objeto únicamente

export const ACTIVE_SPONSOR = {
  id:      'sika',
  name:    'Sika México',
  logo:    '/assets/sika-logo.png',
  website: 'https://www.sika.com.mx',
  tagline: 'Sika — Your Concrete Care Partner',

  // Producto premium por patología
  products: {
    p01_cracks:           'Sikadur-52 Injection LV + SikaTop-122 Plus',
    p02_spalling:         'Sika MonoTop-910 S + Sika MonoTop-412 NFG',
    p03_delamination:     'Sika MonoTop-410 + Sikafloor-81 EpoCem',
    p04_efflorescence:    'Sikagard-703 W + Sika WT-200P',
    p05_popout_asr:       'Sikadur-31 CF + Sikagard-705 L',
    p06_joints:           'Sikaflex-2c NS EZ Mix + Sika Backer Rod',
    p07_corrosion:        'Sika MonoTop-910 S + MonoTop-412 NFG + Sikagard-680 S',
    p08_plastic_shrinkage:'Sika Antisol-E + SikaLatex',
    p09_carbonation:      'Sikagard-680 S BetoShield + MonoTop-910 S',
  },
};

// Helper para obtener el producto del sponsor activo
export function getSponsorProduct(pathologyId) {
  return ACTIVE_SPONSOR?.products?.[pathologyId] || null;
}
